const constant = {
  // 個人情報APIエンドポイント
  PERSONAL_INFO_API: process.env.REACT_APP_PERSONAL_INFO_API,
  // シークレットキー取得APIエンドポイント
  IS_ACCESS: process.env.REACT_APP_IS_ACCESS,
  // パスワードチェック判定エンドポイント
  FORGOT_PASSWORD_CONFIRM: process.env.REACT_APP_FORGOT_PASSWORD_CONFIRM,
  // パスワードチェック判定エンドポイント
  CHANGE_INITIAL_PASSWORD: process.env.REACT_APP_CHANGE_INITIAL_PASSWORD,
  SEARCH_MAILADDRESS: process.env.REACT_APP_SEARCH_MAILADDRESS,
  // サインアップURL（社内）
  SIGNUP_INTERNAL: process.env.REACT_APP_SIGNUP_INTERNAL,
  // サインアップURL（外部）
  SIGNUP_EXTERNAL: process.env.REACT_APP_SIGNUP_EXTERNAL,
};

export { constant };
